/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  /* Start-Boost-214299 */
  InstantSearchMobile.prototype.getTemplate = function(tempType) {
		switch (tempType) {
			case InstantSearchMobile.tempType.SEARCH_BTN:
				return `
					<span class="{{class.searchSuggestionBtnSubmitMobile}}"><span>Submit</span></span>
				`.trim();
			default:
				return `
					<div class="{{class.searchSuggestion}}-mobile-overlay"></div>
					<div class="{{class.searchSuggestion}}-mobile-top-panel">
						<form action="{{storeLocale}}/search" method="get">
							<button type="button" class="{{class.searchSuggestionBtnCloseMobile}}"><-</button>
							{{btnSearch}}
							<input role="textbox" type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />
							<button role="textbox" type="button" class="{{class.searchSuggestionBtnClearMobile}}">X</button>
						</form>
					</div>
				`.trim();
		}
	}

  InstantSearchMobile.prototype.compileTemplate = function() {
    var submitBtn = '';
    // Show search button on mobile OR NOT
    if (Settings.getSettingValue('search.showSearchBtnMobile')) {
      submitBtn = this.getTemplate(InstantSearchMobile.tempType.SEARCH_BTN);
    }
  
    if (Shopify.locale == 'en') {
      return this.getTemplate()
        .replace(/{{storeLocale}}/, '')
        .replace(/{{btnSearch}}/g, submitBtn)
        .replace(/{{searchTermKey}}/g, Settings.getSettingValue('search.termKey'))
        .replace(/{{searchBoxPlaceholder}}/g, Labels.suggestion.searchBoxPlaceholder)
        .replace(/{{searchId}}/g, this.inputMobileId)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionBtnSubmitMobile}}/g, Class.searchSuggestionBtnSubmitMobile)
        .replace(/{{class.searchSuggestionBtnCloseMobile}}/g, Class.searchSuggestionBtnCloseMobile)
        .replace(/{{class.searchSuggestionBtnClearMobile}}/g, Class.searchSuggestionBtnClearMobile);
    } else {
      return this.getTemplate()
        .replace(/{{storeLocale}}/, '/' + Shopify.locale)
        .replace(/{{btnSearch}}/g, submitBtn)
        .replace(/{{searchTermKey}}/g, Settings.getSettingValue('search.termKey'))
        .replace(/{{searchBoxPlaceholder}}/g, Labels.suggestion.searchBoxPlaceholder)
        .replace(/{{searchId}}/g, this.inputMobileId)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionBtnSubmitMobile}}/g, Class.searchSuggestionBtnSubmitMobile)
        .replace(/{{class.searchSuggestionBtnCloseMobile}}/g, Class.searchSuggestionBtnCloseMobile)
        .replace(/{{class.searchSuggestionBtnClearMobile}}/g, Class.searchSuggestionBtnClearMobile);
    }
  }
  /* End-Boost-214299 */

 //    InstantSearchResultItemProduct.prototype.customizeProductTitle = function () {
	// 	// Override this method for customization
 //        var data = this.data;
 //        var scaleTag = data.tags.find(e => e.toLowerCase().indexOf('scale:') > -1)
 //        // var html = `<span> <b> ${this.title} </b> </span>`;
 //        var html = this.title;
 //        if (scaleTag) {
 //          // html += '<br/><span>' + scaleTag.replace('scale:', '') + ' SCALE  </span>';
 //          html +=  scaleTag.replace('scale:', '') + ' SCALE';
          
 //        }
	// 	return html;
	// }
  	InstantSearchResultItemProduct.prototype.getTemplate = function (tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
						<s>{{compareAtPrice}}</s>
						
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
                                <div class="boost-pfs-custom-search">{{scaleTag}}</div>
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}
  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
		if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

            // Custom code
            var data = this.data;
            var scaleTag = data.tags.find(e => e.toLowerCase().indexOf('scale:') > -1)
            var scaleTagHtml = ''
            if (scaleTag) {
                scaleTagHtml =  scaleTag.replace('scale:', '') + ' SCALE';
              }
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
                .replace(/{{scaleTag}}/g, scaleTagHtml);
		} else {
			return '';
		}
	}

  // in the file boost-pfs-instant-search.js  
  InstantSearchApi.beforeCall = function(eventType, eventInfo) {
    if (Shopify && Globals) {
          Globals.instantSearchQueryParams.country = Shopify.country;
        Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
        Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
        Globals.instantSearchQueryParams.return_all_currency_fields = false;
    }
  }

})();